import { Box, Container, Divider, Grid, Typography } from '@material-ui/core';
import { useSnackbar } from 'notistack';
import React from 'react';
import {
  ACTIONS,
  useSessionSchedulerContext,
} from '../../../../Context/sessionSchedulerContextForExam';
import useConfirm from '../../../../global_components/hooks/ConfirmHook';
import KenButton from '../../../../global_components/KenButton';
import {
  getBookedSlotDelete,
  sessionCUD,
  updateReferenceActivities,
} from '../../../../Utils/apiServices';
import { useAppContext } from '../../../../Utils/context';
import { EVENT_TYPES } from '../../../../Utils/helper/schedulerExamHelper';

export default function ViewReferenceSession(props) {
  const {
    eventType,
    activity,
    startDate,
    endDate,
    startTime,
    endTime,
    FacilityBooking,
    FacultyBooking,
    SubjectPlanner,
    academicPlannerActivityId,
    onClose,
    //reference related props
    subjectCourseName,
    activityType,
    faculty1Name,
    faculty2Name,
    faculty3Name,
    subjectId = '',
    id,
    //session
    courseName,
    courseOfferingSectionId,
  } = props;

  const {
    state: { term },
    fetchDataByTerm,
    dispatch,
  } = useSessionSchedulerContext();

  const { handleSnackbarOpen, handleLoader } = useAppContext();

  const [Dialog, confirmDelete] = useConfirm(
    'Are you sure?',
    `Are you sure you want to delete ${activity} ?`
  );
  const deleteActivity = async () => {
    // call api to delete
    const payload = {
      Operation: 'Delete',
      FacilityFacultyBooking: {
        academicPlannerActivityId,
      },
    };
    return await getBookedSlotDelete(payload);
  };

  const deleteReference = async () => {
    const payload = {
      Operation: 'Delete',
      Activity: {
        activityId: id,
      },
    };

    // call api to delete

    return await updateReferenceActivities(payload);
  };

  const deleteSession = async () => {
    const payload = {
      Operation: 'Delete',
      Session: [
        {
          sessionId: id,
        },
      ],
    };

    return await sessionCUD(payload);
  };

  const handleDelete = async () => {
    if (!id) {
      handleSnackbarOpen('Please reopening and try again.');
      return;
    }
    const ans = await confirmDelete();
    if (ans) {
      try {
        let res;
        handleLoader(true);
        switch (eventType) {
          case EVENT_TYPES.REFERENCE:
            res = await deleteReference();
            break;

          case EVENT_TYPES.ACTIVITY:
            res = await deleteActivity();
            break;

          case EVENT_TYPES.SESSION:
            res = await deleteSession();
            break;

          default:
            return;
        }

        // add loader and all common logic
        if (res) {
          handleLoader(false);
          fetchDataByTerm(term, { hasToGetVersion: false });
          onClose();
          handleSnackbarOpen('success', 'Deleted successfully');
        } else {
          handleSnackbarOpen('error', 'Please try again. Unable to delete');
        }
      } catch (err) {
        handleLoader(false);
        console.log(err);
      }
    }
  };

  const handleEdit = () => {
    // dispatch({ type: ACTIONS.SET_EVENT_VIEW_FLAG, value: false });
    dispatch({ type: ACTIONS.SET_EVENT_EDIT_FLAG, value: true });
  };

  // Create sessions from reference activity
  const handleCreateSessions = () => {
    dispatch({
      type: ACTIONS.SET_SELECTED_EVENT,
      value: {
        activity: activityType,
        startDate,
        endDate,
        SubjectPlanner: { courseVersionId: subjectId },
        isCreateFromReference: true,
        eventType: EVENT_TYPES.ACTIVITY,
      },
    });
    // dispatch({
    //   type: ACTIONS.SET_EVENT_VIEW_FLAG,
    //   value: false,
    // });
    dispatch({
      type: ACTIONS.SET_EVENT_EDIT_FLAG,
      value: true,
    });
  };

  return (
    <div>
      <Container maxWidth="sm">
        <Box display="flex" justifyContent="space-between" mb={2}>
          <Typography variant="h6">
            <b>View Details</b>
          </Typography>

          <Box display="flex" alignItems="center">
            {eventType === EVENT_TYPES.REFERENCE && (
              <KenButton variant="primary" onClick={handleCreateSessions}>
                Create Exam
              </KenButton>
            )}
            <KenButton
              variant="primary"
              size="small"
              onClick={handleDelete}
              style={{
                float: 'right',
                marginLeft: '8px',
                marginRight: '8px',
              }}
            >
              Delete
            </KenButton>
            <KenButton
              variant="secondary"
              size="small"
              onClick={handleEdit}
              style={{ float: 'right' }}
            >
              Edit
            </KenButton>
          </Box>
        </Box>
        <Divider />
        <Box mt={2}>
          <Grid container spacing={2}>
            <Grid item xs={12} md={3}>
              <b>Session:</b>
            </Grid>
            <Grid item xs={12} md={9}>
              {activity || activityType}
            </Grid>
            <Grid item xs={12} md={3}>
              <b>Start Date:</b>
            </Grid>
            <Grid item xs={12} md={3}>
              {startDate}
            </Grid>
            {(eventType === EVENT_TYPES.ACTIVITY ||
              eventType === EVENT_TYPES.SESSION) && (
              <>
                <Grid item xs={12} md={3}>
                  <b>Start Time:</b>
                </Grid>
                <Grid item xs={12} md={3}>
                  {startTime}
                </Grid>
              </>
            )}
            <Grid item xs={12} md={3}>
              <b>End Date:</b>
            </Grid>
            <Grid item xs={12} md={3}>
              {endDate}
            </Grid>
            {(eventType === EVENT_TYPES.ACTIVITY ||
              eventType === EVENT_TYPES.SESSION) && (
              <>
                <Grid item xs={12} md={3}>
                  <b>End Time:</b>
                </Grid>
                <Grid item xs={12} md={3}>
                  {endTime}
                </Grid>
              </>
            )}
            <Grid item xs={12} md={3}>
              <b>Subject:</b>
            </Grid>
            <Grid item xs={12} md={3}>
              {SubjectPlanner?.courseName ||
                subjectCourseName ||
                courseName ||
                'N/A'}
            </Grid>
            <Grid item xs={12} md={3}>
              <b>Section:</b>
            </Grid>
            <Grid item xs={12} md={3}>
              {SubjectPlanner?.courseOfferingSectionId ||
                courseOfferingSectionId ||
                'N/A'}
            </Grid>
            <Grid item xs={12} md={3}>
              <b>Faculty:</b>
            </Grid>
            <Grid item xs={12} md={3}>
              {FacultyBooking?.facultyName ||
                [faculty1Name, faculty2Name, faculty3Name]
                  .filter((f) => f)
                  .join(',') ||
                'N/A'}
            </Grid>
            <Grid item xs={12} md={3}>
              <b>Facility:</b>
            </Grid>
            <Grid item xs={12} md={3}>
              {FacilityBooking?.facilityName || 'N/A'}
            </Grid>
          </Grid>
        </Box>
        <Box display="flex" justifyContent="end" mt={4}>
          <KenButton variant="secondary" onClick={onClose}>
            Close
          </KenButton>
        </Box>
      </Container>
      <Dialog />
    </div>
  );
}
